export const DELIMITERS = ['\n', ',']

// remove bullet points and preceding whitespace
const trimInput = (splitInput: string[]) => {
  const inputWithoutBulletPoints = splitInput.map(str => str.replace(/^[-•]\s+/, ''))
  return inputWithoutBulletPoints.map(str => str.replace(/^\s*/, ''))
}

// Split a delimited string into an array of strings. The first delimiter takes precedence.
// If the string contains no delimiter return null
export const splitDelimitedStringOrNull = pastedInput => {
  // There are a few possible delimiters here, choose one and roll with it

  let delimiterUsed = null

  // Search for a delimiter, the first delimiter found takes precedence!
  DELIMITERS.some(delimiter => {
    if (pastedInput.indexOf(delimiter) !== -1) {
      delimiterUsed = delimiter
      return true
    }

    return false
  })

  if (!delimiterUsed) return null

  let splitInput = pastedInput.split(delimiterUsed)
  splitInput = trimInput(splitInput)
  // remove blank lines
  splitInput = splitInput.filter(line => line !== '')

  // handle a string that is only delimiters
  if (splitInput.length === 0) return null

  return splitInput
}
